import React, { useState } from "react";
import { Button, Input } from "reactstrap";
import style from "./../Quotebar.module.scss";
import { FormattedDate, FormattedTime } from "react-intl";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import CircularProgress from "./../../CircularProgress/CircularProgress";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";

const spinnerStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  bottom: "30px",
  right: 0,
  margin: "auto",
};

const CrossItem = ({ order, ...props }) => {
  const [values, setValues] = useState({ crossType: "Internal", price: "" });

  const changeValue = (name, value) => {
    setValues({
      ...values,
      [name]: value,
    });
  };

  const setPrice = () => {
    setValues({
      ...values,
      loading: true,
    });

    props
      .setPrice({
        orderId: order.OrderId,
        price: values.price,
        crossType: values.crossType,
      })
      .then((r) => null);
  };

  return (
    <div className={style.quote} style={values.loading ? { position: "relative" } : {}}>
      {values.loading && (
        <div className={style.loading}>
          <CircularProgress style={spinnerStyle} />
        </div>
      )}
      <div className={`message`}>
        <div className={style.icon}>
          <i className="icon-shuffle icons font-2xl d-block mt-1"></i>
        </div>
        <div>
          <small className="text-muted font-weight-bold" style={{ fontSize: "12px" }}>
            Cross price
          </small>
          <small className="text-muted float-right mt-1">
            <FormattedDate value={order.OrderInitDate} />{" "}
            <FormattedTime value={order.OrderInitDate} hour12={false} />
          </small>
        </div>

        <div className={style.detail}>
          {/* Side */}

          {/* Symbol */}
          <div className="text-truncate mr-2">{order.AssetTicker}</div>
          {/* Quantity */}
          <div className={style.quantity}>
            <FormattedNumber value={parseFloat(order.OrderQuantity)} dataTypeDecimalName="quantity" />
          </div>
        </div>
      </div>

      <div className={style.footer}>
        <div>
          {/* Sender / Receiver */}
          <div className="small text-muted text-truncate">{order.OrderAdvisorName}</div>
        </div>
      </div>
      <div className={style.form}>
        <Form onChange={changeValue} setPrice={setPrice} values={values} />
      </div>
    </div>
  );
};

const Form = ({ values, setPrice, onChange }) => (
  <div style={{ display: "flex", marginTop: "5px" }}>
    <div style={{ flexGrow: 1, display: "inline-flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
      <div>
        <NumberFormatInput
          type="text"
          customInput={Input}
          value={values.price}
          disabled={!!values.loading}
          onValueChange={(e) =>
            onChange("price", isNaN(e.floatValue) || e.value.endsWith(".") ? e.value : e.floatValue)
          }
          className={`${style.input} mr-1`}
          placeholder={"Price"}
          dataTypeDecimalName="price"
        />
      </div>
      <div>
        <Input
          type={"select"}
          value={values.crossType}
          onChange={(e) => onChange("crossType", e.target.value)}
          disabled={!!values.loading}
          className={`${style.input} mr-1`}
        >
          <option key={"Bolsa"} value={"Bolsa"}>
            Bolsa
          </option>
          <option key={"Internal"} value={"Internal"}>
            Internal
          </option>
        </Input>
      </div>
    </div>
    <div style={{ color: "black" }}>
      <Button
        onClick={() => setPrice()}
        disabled={values.loading || values.price == ""}
        color="primary"
        size="sm"
        className="float-right ml-1"
      >
        Set price
      </Button>
    </div>
  </div>
);

export default CrossItem;
